export default "__VITE_ASSET__CqZ3KTB6__"